<template>
	<div>
		<v-tabs
			class="pd-0"
			:fixed-tabs="!$vuetify.breakpoint.smAndUp"
			:dark="dark"
			:vertical="!$vuetify.breakpoint.smAndUp"
			:hide-slider="dark"
		>
			<template v-for="aba in abasInicio">
				<v-tab
					active-class="tab-ativa"
					:key="aba.key"
					:to="aba.rota"
					class="tab-header"
					v-az-auth="aba.permissao"
					append
				>
					{{ aba.titulo }}
				</v-tab>
			</template>
			<v-spacer></v-spacer>
			<template v-for="aba in abasFim">
				<v-tab
					active-class="tab-ativa"
					:key="aba.key"
					:to="aba.rota"
					class="tab-header"
					v-az-auth="aba.permissao"
					append
				>
					{{ aba.titulo }}
				</v-tab>
			</template>
		</v-tabs>
		<v-divider></v-divider>
		<router-view ref="childRef"></router-view>
	</div>
</template>

<script>
export default {
	name: 'painel-com-tabs',
	props: {
		abas: {
			type: Array,
			default() {
				return []
			},
		},
		getter: {
			type: String,
			default: null,
		},
		dark: {
			type: Boolean,
		},
	},
	computed: {
		getAbas() {
			if (this.abas.length > 0) return this.abas
			return this.$store.getters[this.getter]
		},
		abasInicio() {
			return this.getAbas.filter((aba) => !aba.tabDireita)
		},
		abasFim() {
			return this.getAbas.filter((aba) => aba.tabDireita)
		},
	},
}
</script>
